export enum PermissiblePurposeDeclineModalFields {
  denialReason = 'denialReason',
}

export type PermissiblePurposeDeclineModalValues = {
  [PermissiblePurposeDeclineModalFields.denialReason]: string;
};
